var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47368 9.26832L6.12034 9.26832L6.53236 8.76991L10.6264 3.81744L10.6264 21.6649L6.44885 17.4537L6.04588 17.0475L5.47369 17.0475L1.37359 17.0475L1.37359 9.26832L5.47368 9.26832Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.74718
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.7071,
    y1: 9.29289,
    x2: 23.7071,
    y2: 17.2929,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.2929,
    y1: 17.2929,
    x2: 23.2929,
    y2: 9.29289,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.0faee1486c06b143eb2aa53afcf3598e.svg";
export { ForwardRef as ReactComponent };